export default {
  cardsWrapper: 'crop-cards-wrapper',
};
